import { BASEPATH } from "../../../utils/constants/constants";

export const SCRT_USER_MANAGEMENT_URL = {
  GET_ADMIN_USER_DETAILS: `${BASEPATH}/usermgmt/getBroadcomAdminUserDetails`,
  ADD_ADMIN_USER_DETAILS: `${BASEPATH}/usermgmt/addNewAdminUser`,
  UPDATE_ADMIN_USER_DETAILS: `${BASEPATH}/usermgmt/updateAdminUserDetails`,
  GET_ADMIN_ROLES_DETAILS: `${BASEPATH}/usermgmt/getAdminRoles`,
  GET_ADMIN_TITLE_DETAILS: `${BASEPATH}/usermgmt/getAdminTitles`,
};